import React from 'react';
import { isBrokerOrganisation, isOwner } from '../../../auth/redux/authActions';
import { Box, SelectSource } from '../../../../common/components';
import './SourceSelect.scss';

const SourceSelect = ({
  sourceFilters,
  handleSourceChange,
  isClearable,
  isDisabled,
  value,
}) => {
  if (!isOwner() && !isBrokerOrganisation()) {
    return null;
  }

  const sourceDropdown = value?.id
    ? {
        value: value?.id,
        label: value?.attributes.name,
      }
    : undefined;

  return (
    <Box className="source-select-container">
      <div className="source-select-container--title">
        <h4>Quotation Source</h4>
      </div>
      <div className="source-select-container--body">
        <div className="source-select-container--select">
          <SelectSource
            name="data.relationships.source.data"
            isObject
            filters={sourceFilters}
            onChangeCallback={handleSourceChange}
            component={SelectSource}
            isClearable={isClearable}
            includes={'&include=broker,channel'}
            disabled={isDisabled}
            value={sourceDropdown}
            extraIncludedNames={['broker', 'channel']}
            id={'select-source'}
          />
        </div>
      </div>
    </Box>
  );
};

export default SourceSelect;
